import { EditorialMessageContent } from "./EditorialMessageContent";
import { DataRelatedBuilder } from "./DataRelatedBuilder";
import { AuthorMini } from "../../shared/models/Author";
import { PostI3 } from "../../shared/models/postI3";
import { truncateSummary } from "../services/summary.service";
import { getImagePath } from "../utils/pathHelper";
import { MessageContent } from "./MessageContent";

export class RecordingDataRelatedBuilder implements DataRelatedBuilder <PostI3> {
  build(post: PostI3, content: EditorialMessageContent, author: AuthorMini): MessageContent {

    content.relatedRecordingContent = {
      LiveVideoId: post.id,
      LiveVideoUrl: post.url,
      VideoUrl: post.videoUrl,
      FeedId: post.feedId,
      Title: post.title,
      PublicationDateUtc: post.publicationDate,
      Duration: post.videoDurationSeconds,
      AuthorName: author.Name,
      AuthorImageUrl: getImagePath(author.UrlPhoto, "XtraSmall"),
      Summary: truncateSummary(post.summary),
      IsPremium: post.isPremium,
      ImageUrl: getImagePath(post.imageUrl, "Small")

    }
    content.relatedPostContent = null;
    content.relatedWebinarContent = null;
    content.relatedCalendarEventContent = null;
    return content;
  }
}


// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/RecordingDataRelatedBuilder.ts